import { cookieState, ALLOW_COOKIES } from '@composables/useStorage.js'
import { boot, exchangeIDtokenForAccessToken } from '@services'
import { CSS_ID } from '@config/htmlIDs.js'
import i18n from '@plugins/localisation.js'
import { isObj } from '@helpers/utils.js'
import { MIN_PAGE_HEIGHT } from '@config'
import { readonly, ref } from 'vue'
import DOMPurify from 'dompurify'
import {
  setFilterSetting,
  filterSettings,
  setAuthOption,
  ALLOWED_URLS,
  setSettings,
  AuthOptions,
  setStyle,
  Settings,
  HOST_URL,
  HEADERS,
  Style,
} from '@config/game.js'

export const authState = ref({})
const scrollState = ref({})
export const containerScroll = readonly(scrollState)
export const containerHeight = ref(0)
export const hostUrl = ref(location.href.split('#')[0])
export const windowHeight = ref(MIN_PAGE_HEIGHT)

export function sendMessage(msg) {
  window.parent.postMessage(msg, HOST_URL)
}

export default function () {
  window.addEventListener('message', (e) => {
    if (
      (!import.meta.env.DEV && !ALLOWED_URLS.includes(e.origin)) ||
      !e.data ||
      !isObj(e.data)
    )
      return

    const {
      modioAllowCookies,
      modioSettings,
      modioPlatform,
      modioWindow,
      modioFilter,
      modioPortal,
      modioScroll,
      modioStyle,
      modioAuth,
      modioLang,
      modioUrl,
      modioCSS,
    } = e.data

    if (modioUrl) {
      hostUrl.value = modioUrl.split('#')[0]
    }

    if (Number.isInteger(modioWindow)) {
      windowHeight.value = modioWindow
    }

    if (modioStyle) {
      Object.keys(Style.value).forEach((key) => setStyle(key, modioStyle[key]))
    }

    if (modioCSS) {
      let elem = document.getElementById(CSS_ID)
      if (!elem) {
        elem = document.createElement('style')
        document.getElementsByTagName('head')[0].appendChild(elem)
      }
      elem.innerHTML = DOMPurify.sanitize(modioCSS)
    }

    if (modioAllowCookies !== undefined) {
      const allow = ['1', 1, 'true', true].includes(modioAllowCookies)
      cookieState.value = allow ? ALLOW_COOKIES : 0
    }

    if (modioLang) {
      i18n.global.locale.value = modioLang
    }

    if (modioSettings) {
      Object.keys(Settings.value).forEach((key) =>
        setSettings(key, modioSettings[key])
      )

      Object.keys(AuthOptions.value).forEach((key) =>
        setAuthOption(key, modioSettings[key])
      )
    }

    if (modioFilter) {
      Object.keys(filterSettings.value).forEach((key) =>
        setFilterSetting(key, modioFilter[key])
      )
    }

    if (modioScroll) {
      scrollState.value = modioScroll
    }

    if (modioPortal) {
      HEADERS.portal = modioPortal
    }

    if (modioPlatform) {
      HEADERS.platform = modioPlatform
    }

    if (modioAuth) {
      const { id_token, access_token, email } = modioAuth
      if (id_token) {
        exchangeIDtokenForAccessToken(id_token, email)
      } else if (access_token) {
        boot({ access_token })
      }
    }
  })

  sendMessage({ modioInit: true })
}
